import { useEffect, useReducer, useState } from 'react';
import {
  getOptimizelyVariation,
  isOptimizelyVariationActive,
  VariationType,
} from './optimizely';

const useOptimizelyVariation = (
  experimentName: string | undefined,
  enableOnTests = true,
  targetVariation: VariationType = 'Variation #1',
  maxTries = 5
): boolean => {
  const [isVariationActive, setIsVariationActive] = useState(false);
  const [leftTries, countTriesDown] = useReducer((tries: number) => tries - 1, maxTries);

  useEffect(() => {
    if (!isVariationActive) {
      const timeout = setInterval(() => {
        if (!leftTries) {
          clearInterval(timeout);
          return;
        }
        if (typeof window === 'undefined') {
          return;
        }
        const variationName = getOptimizelyVariation(experimentName);
        const optimizelyVariationActive = isOptimizelyVariationActive(
          variationName,
          targetVariation,
          enableOnTests
        );
        if (optimizelyVariationActive) {
          setIsVariationActive(true);
          clearInterval(timeout);
          return;
        }
        countTriesDown();
      }, 500);

      return () => clearInterval(timeout);
    }
  }, [enableOnTests, experimentName, targetVariation, isVariationActive, leftTries]);

  return isVariationActive;
};

export default useOptimizelyVariation;
